import {IAnyObject, INumberObject} from "../../common/SimpleInterface";
import PostFieldConfig from "../config/PostFieldConfig";
import {isArray} from "../../common/SiteHelper";

export type PostType = "organisation" | "career" | "project" | "offer" | "page";
export type PostFieldType = "post_data" | "taxonomies" | "acf_meta" | "wp_meta";
export type PostStatus = "publish" | "draft" | "pending" | "expired" | "unknown";

export class PostConfig
{
    type:PostType;
    name:string;
    plural:string;
    aName:string;
    addPageID:string|null;

    constructor(type:PostType, name:string, plural:string, aName:string, addPageID:string|null = null)
    {
        this.type = type;
        this.name = name;
        this.plural = plural;
        this.aName = aName;
        this.addPageID = addPageID;
    }
}

type IPostConfigs = {
    [key in PostType]: PostConfig
};

type IPostFieldConfigs = {
    [key in PostType]: PostFieldConfig
};

export default class PostManager
{
    postTypes: PostType[] = ["organisation", "career", "project", "offer", "page"];
    postFieldTypes: PostFieldType[] = ["post_data", "taxonomies", "acf_meta", "wp_meta"];

    postOrganisationIDs:INumberObject = {};

    config: IPostConfigs = {
        project: new PostConfig("project", "Project", "Projects", "a Project",  "create_a_project"),
        offer: new PostConfig("offer", "Offer", "Offers", "an Offer", "post_an_offer"),
        career: new PostConfig("career", "Career", "Careers", "a Career",  "submit_a_career"),
        organisation: new PostConfig("organisation", "Organisation", "Organisations", "an Organisation", "register_an_organisation"),
        page: new PostConfig("page", "Page", "Pages", "a Page")
    };

    postFieldConfig: IPostFieldConfigs = {
        organisation: new PostFieldConfig("organisation"),
        career: new PostFieldConfig("career"),
        project: new PostFieldConfig("project"),
        offer: new PostFieldConfig("offer"),
        page: new PostFieldConfig("page")
    };

    postStatusNames:{
        [key in PostStatus]: string
    } = {
        publish: "Published",
        draft: "Unpublished",
        pending: "Pending Review",
        expired: "Closed",
        unknown: "Unknown"
    }

    constructor()
    {

    }

    applyPostFieldConfigs(postFields:IAnyObject):void
    {
        const organisation = postFields.organisation ?? [];
        const career = postFields.career ?? [];
        const project = postFields.project ?? [];
        const offer = postFields.offer ?? [];
        if(isArray(organisation)){
            this.postFieldConfig.organisation.apply(organisation);
        }
        if(isArray(career)){
            this.postFieldConfig.career.apply(career);
        }
        if(isArray(project)){
            this.postFieldConfig.project.apply(project);
        }
        if(isArray(offer)){
            this.postFieldConfig.offer.apply(offer);
        }
    }
}